import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatTabChangeEvent, MatTabGroup} from '@angular/material/tabs';
import {PatientService} from '../../modules/patient/patient.service';
import {Globals} from '../../globals';
import {PatientDataModel} from '../../models/patient/patient-data.model';
import {ContactDataModel} from '../../models/person/contact-data.model';
import {MatCheckbox} from '@angular/material/checkbox';
import {NotificationNeededItemDataModel} from '../../models/messaging/noteToFront/notification-needed-item-data.model';
import {EnumValidValueItemModel} from '../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../services/static-data.service';
import {LetterDeliveryToRoleEnum} from '../../models/enum/letter-delivery-to-role.enum';
import {DoctorsService} from '../../services/doctors.service';
import {DoctorDataModel} from '../../models/doctors/doctor-data.model';
import {DoctorQueryOptionsModel} from '../../models/doctors/doctor-query-options.model';

@Component({
  selector: 'app-letters-recipients-dialog',
  templateUrl: './letters-recipients-dialog.component.html',
  styleUrls: ['./letters-recipients-dialog.component.scss']
})
export class LettersRecipientsDialogComponent implements OnInit {
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  patientData: PatientDataModel;
  doctors: DoctorDataModel[] = [];
  referringDoctors: DoctorDataModel[] = [];

  selectedItem: any;
  selectedContacts: ContactDataModel[] = [];
  neededItems: NotificationNeededItemDataModel[] = [];

  letterDeliveryToRoleEnums: EnumValidValueItemModel[] = [];
  letterDeliveryEmailTypeEnums: EnumValidValueItemModel[] = [];

  constructor(private dialogRef: MatDialogRef<LettersRecipientsDialogComponent>,
              private globals: Globals,
              private staticDataService: StaticDataService,
              private doctorService: DoctorsService,
              private patientService: PatientService) { }

  ngOnInit(): void {
    this.setupEnums();
    const ivl = setInterval(() => {
      if (this.tabGroup) {
        clearInterval(ivl);
        this.tabGroup.selectedIndex = 0;
        this.tabGroup.focusTab(0);
      }
    }, 100);
  }

  setupEnums() {
    if (this.staticDataService.isReady) {
      this.letterDeliveryToRoleEnums = this.staticDataService.getValidValueItemsByValidValueName('enumLetterDeliveryToRole');
      this.letterDeliveryEmailTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumLetterDeliveryEmailType');
      this.loadPatientData();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.letterDeliveryToRoleEnums = this.staticDataService.getValidValueItemsByValidValueName('enumLetterDeliveryToRole');
          this.letterDeliveryEmailTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumLetterDeliveryEmailType');
          this.loadPatientData();
        }
      });
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    // return selections
    this.dialogRef.close({neededItems: this.neededItems, selectedContacts: this.selectedContacts });
  }

  onTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Current':
        this.loadPatientData();
        break;
      case 'Doctor':
        const model = new DoctorQueryOptionsModel();
        model.isIncludeReferring = false;
        model.isIncludeTdo = true;
        model.isLazyLoad = true;
        this.doctorService.getDoctors(model).subscribe((drRes) => {
          this.doctors = drRes;
        });
        break;
      case 'Referring':
        const model1 = new DoctorQueryOptionsModel();
        model1.isIncludeReferring = true;
        model1.isIncludeTdo = false;
        model1.isLazyLoad = true;
        this.doctorService.getDoctors(model1).subscribe((drRes) => {
          this.referringDoctors = drRes;
        });
        break;
      case 'General':

        break;
      case 'Patient':

        break;
    }
  }

  loadPatientData() {
    this.patientService.getPatient(this.globals.currentPatientId).subscribe((res) => {
      this.patientData = res['ThePatient'];
    });
  }

  getEmail(dataContact: ContactDataModel) {
    const email = dataContact.dataContactComms.find(p => p.enumCommMethodID === '00000009-1000-0000-0000-000000000004');
    if (email) {
      return email.Address;
    }

    return 'No email added';
  }

  onContactClick(dataContact: ContactDataModel, toRoleEnum: string, cb: MatCheckbox) {
    if (this.getEmail(dataContact).length === 0) {
      return;
    }

    if (cb.checked) {
      const idx = this.selectedContacts.findIndex(p => p === dataContact);
      if (idx > -1) {
        this.selectedContacts.splice(idx, 1);
      }
      const idx1 = this.neededItems.findIndex(p => p.ToContactID === dataContact.ContactId);
      if (idx1 > -1) {
        this.neededItems.splice(idx1, 1);
      }
      this.selectedItem = null;
      cb.checked = false;
    } else {
      if (!this.selectedContacts.includes(dataContact)) {
        this.selectedContacts.push (dataContact);
      }
      if (!this.neededItems.find(p => p.ToContactID === dataContact.ContactId)) {
        const needed = new NotificationNeededItemDataModel();
        needed.ToContactID = dataContact.ContactId;
        needed.enumLetterDeliveryToRoleID = toRoleEnum;

        switch (toRoleEnum) {
          case LetterDeliveryToRoleEnum.PATIENT:
            needed.contactType = 'patient';
            break;
          case LetterDeliveryToRoleEnum.DOCTOR:
            needed.contactType = 'doctor';
            break;
          case LetterDeliveryToRoleEnum.REFERRING_DOCTOR:
            needed.contactType = 'referringDoctor';
            break;
          case LetterDeliveryToRoleEnum.GENERAL_DOCTOR:
            needed.contactType = 'generalDoctor';
            break;
          case LetterDeliveryToRoleEnum.OTHER:
            needed.contactType = 'other';
            break;
        }

        this.neededItems.push (needed);
      }
      this.selectedItem = dataContact;
      cb.checked = true;
    }
  }

  getFullnameFromItem(item: NotificationNeededItemDataModel) {
    switch (item.contactType) {
      case 'patient':
        // Check patient, then patient contacts
        if (item.ToContactID === this.patientData.dataContact.ContactId) {
          const contact = this.patientData.dataContact;
          return contact.FirstName + ' ' + contact.LastName;
        } else {
          const contact = this.patientData.dataPatientContacts.find(p => p.ContactId === item.ToContactID);
          if (contact) {
            const contact1 = this.patientData.dataPatientContacts.find(p => p.ContactId === item.ToContactID);
            if (contact1) {
              return contact1.dataContact.FirstName + ' ' + contact1.dataContact.LastName;
            } else {
              return '';
            }
          } else {
            return '';
          }
        }
        break;
    }

    switch (item.enumLetterDeliveryToRoleID) {
      case LetterDeliveryToRoleEnum.PATIENT:
        // Check patient, then patient contacts
        if (item.ToContactID === this.patientData.dataContact.ContactId) {
          const contact = this.patientData.dataContact;
          return contact.FirstName + ' ' + contact.LastName;
        } else {
          const contact = this.patientData.dataPatientContacts.find(p => p.ContactId === item.ToContactID);
          if (contact) {
            return contact.dataContact.FirstName + ' ' + contact.dataContact.LastName;
          } else {
            return '';
          }
        }
        break;
    }
  }

  getEmailFromItem(item: NotificationNeededItemDataModel) {
    switch (item.contactType) {
      case 'patient':
        // Check patient, then patient contacts
        if (item.ToContactID === this.patientData.dataContact.ContactId) {
          return this.getEmail(this.patientData.dataContact);
        } else {
          const contact = this.patientData.dataPatientContacts.find(p => p.ContactId === item.ToContactID);
          if (contact) {
            return this.getEmail(contact.dataContact);
          } else {
            return '';
          }
        }
        break;
      default:

        break;
    }
  }

  getRoleFromItem(item: NotificationNeededItemDataModel) {
    const enu = this.letterDeliveryToRoleEnums.find(p => p.ValidValueItemId === item.enumLetterDeliveryToRoleID);
    if (enu) {
      return enu;
    }
    return '';
  }

  onRoleChange(event: any, item: NotificationNeededItemDataModel) {
    item.enumLetterDeliveryToRoleID = event.value.ValidValueItemId;
  }

  onEmailDeliveryTypeChange(event: any, item: NotificationNeededItemDataModel) {
    item.enumLetterDeliveryEmailTypeID = event.value.ValidValueItemId;
  }

  getTypeValue(item: NotificationNeededItemDataModel) {
    const enu = this.letterDeliveryToRoleEnums.find(p => p.ValidValueItemId === item.enumLetterDeliveryToRoleID);
    if (enu) {
      return enu;
    }
  }

  getRoleValue(item: NotificationNeededItemDataModel) {
    const enu = this.letterDeliveryToRoleEnums.find(p => p.ValidValueItemId === item.enumLetterDeliveryToRoleID);
    if (enu) {
      return enu;
    }
  }

  deleteItem(item: NotificationNeededItemDataModel) {
    const idx1 = this.selectedContacts.findIndex(p => p.ContactId === item.ToContactID);
    if (idx1 > -1) {
      this.selectedContacts.splice(idx1, 1);
    }
    const idx = this.neededItems.findIndex(p => p === item);
    if (idx > -1) {
      this.neededItems.splice(idx, 1);
    }
  }
}
